<template>
  <aside>
    <div v-if="currentElement.hasOwnProperty('clazz')" id="node-form">

      <div class="form-group">
        <label class="form-control-label">Node Label</label>
        <input @input="updateName($event.target.value)" :value="currentNode.label" type="text" class="form-control form-control-sm">
      </div>
      <detail-panel-snippet v-on="$listeners" />

      <b-button @click="del" variant="danger" size="sm">Delete Node</b-button>
    </div>

    <Anchor v-else-if="currentElement.hasOwnProperty('relatedLines') && currentElement.relatedLines.length" />

    <Canvas v-else id="canvas-form" />

  </aside>
</template>
<script>
  import detailPanelSnippet from './detail-panel-snippets'
  import { mapState, mapMutations } from 'vuex'
  import { calcBBox } from '../utils/nodes'
  import Canvas from './detail-panel-snippets/Canvas'
  import Anchor from './detail-panel-snippets/Anchor'

  export default {
    components: {
      detailPanelSnippet,
      Canvas,
      Anchor,
    },
    data() {
      return {
        text: '',
        type: 'Approved',
      }
    },
    computed: {
      ...mapState('diagramBuilder', [
        'currentNode',
        'currentLines',
        'currentElement',
        'lines'
      ]),
    },
    methods: {
      ...mapMutations('diagramBuilder', [
        'updateNode',
        'deleteNode',
      ]),
      updateName(input){
        let updatedNode = Object.assign({}, this.currentNode, {label: input})
        const g = document.querySelector(`g#${this.currentNode.id}`)
        // adjust node size
        if (g) {
          Object.assign(updatedNode, {height: calcBBox(g).height, width: calcBBox(g).width})
        }
        this.updateNode(updatedNode)
      },
      del() {
        /* remove line cascade */
        let that = this

        if (this.currentNode) {
          function removeRelatedLines(id) {
            let arr = []
            that.lines.forEach(line => {
              // connectors have IDs like node.id + 'top'/'left'/...
              if (line.source.includes(id) || id === line.target) {
                arr.push(line.id)
              }
            })
            that.$emit('remove-leader-lines', arr)
          }

          // node-node connections
          removeRelatedLines(this.currentNode.id)

          // node-outcome connections
          if (this.currentNode.hasOwnProperty('outcomes')) {
            this.currentNode.outcomes.forEach(outcome => {
              removeRelatedLines(outcome.id)
            })
          }
          this.deleteNode(this.currentNode.id)
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  aside{
    padding: 1em .5rem;
    background: #ffffff;
    overflow-y: scroll;
    .color-picker-wrapper{
      height: 100%; 
      width: 100%;
      position: relative;
      .hu-color-picker{
        width: 100%;
      }
    }
  }
</style>